import {faCheck, faXmark} from '@fortawesome/pro-solid-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {Typography} from 'antd';

import {Locale} from '../../../../../../provider/locale/locale';
import {aiMonitoringSignalLangKeyMap} from '../../../../../../service/ai-brand-monitoring/ai-brand-monitoring-const';
import {AiMonitoringBrandAnalysisType} from '../../../../../../service/ai-brand-monitoring/ai-brand-monitoring-type';

import * as styles from './visibility-signal-row.scss';

type PropsType = {
    signal: AiMonitoringBrandAnalysisType['visibility']['signals'][number];
};

// One web-presence signal and whether the analysis found the brand there.
export function VisibilitySignalRow(props: PropsType): JSX.Element {
    const {signal} = props;
    const label = <Locale stringKey={aiMonitoringSignalLangKeyMap[signal.key]} />;
    const iconClassName = signal.found ? styles.visibility_signal_row__found : styles.visibility_signal_row__missing;

    return (
        <div className={styles.visibility_signal_row}>
            <FontAwesomeIcon className={iconClassName} icon={signal.found ? faCheck : faXmark} />
            {signal.found ? (
                <Typography.Text>{label}</Typography.Text>
            ) : (
                <Typography.Text type="secondary">{label}</Typography.Text>
            )}
        </div>
    );
}
